import * as Yup from 'yup';
import { Formik } from 'formik';
import React, { Fragment } from 'react';
import { ModalComponent } from 'components/layout/modals/ModalComponent';
import { ApplicantDropdown } from 'components/layout/form-fields/inputs/ApplicantDropdown';
import { jobPositionStore } from 'ats/pages/job-positions/JobPositionStore';
import { notificationStore } from 'components/layout/notifications/NotificationStore';

const ValidationSchema = Yup.object().shape({
	applicant: Yup.object().required().label('Applicants')
});

export class AddApplicantsModal extends ModalComponent {
	getInitialValues() {
		return {
			applicant: null
		};
	}

	render() {
		return (
			<Formik
				initialValues={this.getInitialValues()}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.create(values);
				}}>
				{formikBag =>
					this.renderModalContainer(formikBag, 'AddApplicantsModal')
				}
			</Formik>
		);
	}

	renderForm(formikBag) {
		return (
			<Fragment>
				<div className="columns">
					<div className="column is-full">
						<div className="field has-text-left">
							<label className="subtitle is-7">Candidate</label>
							<div className="control">
								<ApplicantDropdown
									placeholder="Candidate"
									onValueChange={value => {
										formikBag.setFieldValue('applicant', value);
									}}
									value={formikBag.values.applicant}
									showAvatar
								/>
							</div>
						</div>
					</div>
				</div>
			</Fragment>
		);
	}

	async create(values) {
		try {
			const result = await jobPositionStore.addApplicant(this.props.job.id, {
				applicantId: values.applicant.id
			});

			if (result.status === 'success') {
				this.resultNotification(result, 'Candidate', 'Add');
			} else {
				const errorMessage =
					result.message || 'An error has occurred. Please try again.';
				notificationStore.pushNotification({
					type: notificationStore.ERROR_NOTIFICATION,
					title: 'Add Candidate',
					message: errorMessage
				});
				// Unblock submit button so user can retry
				this.saving(false);
			}
		} catch (error) {
			notificationStore.pushNotification({
				type: notificationStore.ERROR_NOTIFICATION,
				title: 'Add Candidate',
				message: 'An error has occurred. Please try again.'
			});
			// Unblock submit button so user can retry
			this.saving(false);
		}
	}
}
